import {
  Facebook,
  GitHub,
  Instagram,
  MailOutline,
  Phone,
  Room,
  Twitter,
} from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const TopContainer = styled.div`
  background-color: #222726;
  padding-bottom: 20px;
`;
const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  height: 40%;
  @media only screen and (max-width: 760px) {
    display: grid;
  }
`;
const ContainerLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin-left: 30px;
  @media only screen and (max-width: 760px) {
    margin-left: 10px;
  }
`;

const Title = styled.h1`
  color: #fcfcfc;
`;

const Desc = styled.p`
  color: #fcfcfc;
  margin: 5px 0px;
`;

const SocialContainer = styled.div`
  display: flex;
`;

const Acknowlegment = styled.span`
  margin-top: 40px;
  color: #fcfcfc;
  font-size: 20px;
  margin: 42%;

  @media only screen and (max-width: 760px) {
    margin: 25px;
  }
`;
const SocialIcon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: white;
  background-color: #${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  margin-top: 7px;
`;

const ContainerCenter = styled.div`
  flex: 1;
  padding: 20px;
  margin-left: 130px;
  @media only screen and (max-width: 760px) {
    margin-left: 10px;
  }
`;

const List = styled.ul`
  color: #fcfcfc;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;
const ListItem = styled.li`
  width: 40%;
  margin-bottom: 10px;
  color: #fcfcfc;
  cursor: pointer;
`;
const ContainerRight = styled.div`
  flex: 1;
  padding: 20px;
  margin-left: 90px;
  @media only screen and (max-width: 760px) {
    margin-left: 10px;
  }
`;

const ContactItem = styled.div`
  color: #fcfcfc;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;
const Payment = styled.img`
  width: 50%;
`;

const Footer = () => {
  const navigation = useNavigate();

  const navFunc = (route) => {
    navigation(route);
  };

  return (
    <TopContainer>
      <Container>
        <ContainerLeft>
          <Title>Zoopster Pvt.</Title>
          <Desc>
            Zoopster-clothing is an e-commerce website built using React and
            Firebase, offering a seamless shopping experience with user
            authentication and real-time data storage. Shop the latest fashion
            trends with ease!
          </Desc>
          <SocialContainer>
            <SocialIcon color="3B5999">
              <Facebook />
            </SocialIcon>

            <SocialIcon color="55ACEE">
              <Twitter />
            </SocialIcon>

            <SocialIcon color="E4405F">
              <Instagram />
            </SocialIcon>

            <SocialIcon color="272524">
              <GitHub />
            </SocialIcon>
          </SocialContainer>
        </ContainerLeft>

        <ContainerCenter>
          <Title>Useful Links</Title>
          <List>
            <ListItem onClick={() => navFunc("/")}>Home</ListItem>
            <ListItem onClick={() => navFunc("/shop")}>Category</ListItem>
            <ListItem onClick={() => navFunc("/shop/womens")}>Woman </ListItem>
            <ListItem onClick={() => navFunc("/shop/sneakers")}>
              Sneakers
            </ListItem>
            <ListItem onClick={() => navFunc("/shop/jackets")}>
              Jackets
            </ListItem>
            <ListItem onClick={() => navFunc("/checkout")}>Cart</ListItem>
            <ListItem onClick={() => navFunc("/auth")}>Sign-In</ListItem>
          </List>
        </ContainerCenter>

        <ContainerRight>
          <Title>Contact</Title>
          <ContactItem>
            <Room style={{ marginRight: "5px" }} />
            New Delhi, India🇮🇳
          </ContactItem>
          <ContactItem>
            <Phone style={{ marginRight: "5px" }} />
            +91 983223xxxx
          </ContactItem>
          <ContactItem>
            <MailOutline style={{ marginRight: "5px" }} />
            contact@zoopster.com
          </ContactItem>
          <Payment src="https://i.ibb.co./Qfvn4z6/payment.png" />
        </ContainerRight>
      </Container>
      <Acknowlegment>Designed by Tushar in 2022.</Acknowlegment>
    </TopContainer>
  );
};

export default Footer;
